import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

function GlobalProduction({foodAnswers, foodName}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let globalProduction = foodAnswers.answerKeyValues['historical_global_production'];
	let globalProductionYear = foodAnswers.answerKeyValues['historical_global_production_year'];
	let globalProductionSourceRef = foodAnswers.answerKeyValues['historical_global_production_sources'];
	let globalProductionNotes = foodAnswers.answerKeyValues['historical_global_production_notes'];
	let globalProductionUnit = foodAnswers.answerKeyValues['historical_global_production_unit'] || "Metric Tons";
	
	let array = [];
	let dataSeries = [];
	let xCategories = [];
	let seriesObj = {};
	let countries = [];
	let countryValues = [];
	if(globalProduction){
		try {
			array =  JSON.parse(globalProduction);
		} catch (err) {
			console.log("GlobalProduction :globalProduction: " +err);
		}
		array.map( (obj ) =>{
			if(countries.indexOf(obj.country) == -1){
				countries.push(obj.country);
			}
		})
		xCategories = array.map(function (obj) {
		    return [parseInt(obj["year"])];
		});
	}
	countries.map( (country ) =>{
		countryValues = [];
		seriesObj = {};
		seriesObj["name"] = country;
		array.map(function (obj){
			if(obj.country === country && obj["quantity_mts_"]){
				countryValues.push(parseFloat(obj["quantity_mts_"].replace(/,/g, '')));
			}
		})
		seriesObj["data"] = countryValues;
		dataSeries.push(seriesObj);
	})

	return(
			<div>
				{(dataSeries && dataSeries.length > 0) ? <><h2 style={{textAlign: "center"}}>
					Historic Global Production of {foodName}
					{globalProductionYear ? 
					<small>&nbsp;({globalProductionYear})</small>
					: ""}
					{ globalProductionSourceRef && globalProductionSourceRef > 0 ?
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+globalProductionSourceRef}>{globalProductionSourceRef}</a></small>:
					""	
					}
				</h2>
				<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
				options={{
					chart: {
				        type: 'column'
				    },
				    credits: {
                        enabled: false
					},
					lang: {
						thousandsSep: ','
					},
					title: {
						text: ''
			  		},
				  	yAxis: {
			          title:  {
						text: globalProductionUnit
				  		},
				  		stackLabels: {
				            enabled: true,
				            style: {
				                fontWeight: 'bold',
				                color: ( // theme
				                    Highcharts.defaultOptions.title.style &&
				                    Highcharts.defaultOptions.title.style.color
				                ) || 'gray',
				                textOutline: 'none'
				            }
			       		}
			        },
			        xAxis: {
			          title:  {
						text: ''
				  		},
				  	  categories: xCategories	
			        },
			        tooltip: {
				        headerFormat: '<b>{point.x}</b><br/>',
				        pointFormat: '{series.name}: {point.y}'
				    },
				    plotOptions: {
				        column: {
				            stacking: 'normal',
				            dataLabels: {
				                enabled: true
				            }
				        }
				    },
				    legend: {
				       symbolRadius: 0
				    },
					series: dataSeries
				}}
				/>
				{globalProductionNotes  ?
				<p className="notes-info" style={{marginTop: "-50px"}}>
				<em>
				{globalProductionNotes}
				</em>
				</p>
				:""}
				</>:""}
			</div>
		)
}
export default GlobalProduction;